import Trait from './trait';

class TraitValue {
  static all() {
    return Trait.all().reduce((allValues, trait) => allValues.concat(trait.values), []);
  }

  static findByUuid(uuid) {
    return TraitValue.all().find(traitValue => traitValue.uuid === uuid);
  }

  constructor(trait, config) {
    this.trait = trait;
    this.uuid = config.uuid;
    this.slug = config.slug;
    this.name = config.name;
  }
}

export default TraitValue;



// WEBPACK FOOTER //
// ./javascripts/components/taxonomy/trait_value.js